<template>
  <div>
    <BaseModal ref="modal" v-model="modalShow" size="lg">

      <div class="card">

        <!--cabezera-->
        <div class="card-header">

          <div class="d-flex">
            <div class="flex-fill">
              <KarinNotificationSearch></KarinNotificationSearch>
            </div>

            <div class="float-end">
              <KarinNotificationPagination></KarinNotificationPagination>
            </div>

          </div>

        </div>

        <!--cuerpo-->
        <div class="card-body">
          <KarinNotificationTable></KarinNotificationTable>
        </div>
      </div>
    </BaseModal>
  </div>
</template>
<script>
import KarinNotificationSearch from "@/components/KarinLaw/KarinMenu/KarinNotification/Karin-notification-search.vue";
import KarinNotificationPagination
  from "@/components/KarinLaw/KarinMenu/KarinNotification/Karin-notification-pagination.vue";
import KarinNotificationTable
  from "@/components/KarinLaw/KarinMenu/KarinNotification/Karin-notification-table.vue";
import BaseModal from "@/components/shared/Base-modal.vue";
import { EventNames } from "@/plugins/enums";

export default {
  name: 'KarinNotification',

  data() {
    return {
      modalShow: false,
    }
  },

  components: {
    KarinNotificationPagination,
    KarinNotificationSearch,
    KarinNotificationTable,
    BaseModal
  },

  mounted() {
    this.$eventBus.$on(EventNames.KarinOpenNotificationModal, async () => {
      this.modalShow = true;
    });
  },
}
</script>
<style></style>
